/**
 * LockedGateScreen - Shows what's needed to unlock a level
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LockClosedIcon, AcademicCapIcon } from '@heroicons/react/24/outline';

const LockedGateScreen = ({ error, unlocks, level }) => {
  const navigate = useNavigate();

  const levelNames = {
    level_1: 'Level 1: Reading the Room',
    level_2: 'Level 2: Managing Tradeoffs',
    level_3: 'Level 3: System Mastery'
  };

  const requirements = {
    level_1: 'Complete the Basic learning path',
    level_2: 'Complete the Intermediate learning path',
    level_3: 'Complete the Advanced learning path'
  };

  const levelName = levelNames[level] || 'This Level';
  const requirement = requirements[level] || 'Complete required learning';

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center p-4">
      <motion.div
        className="max-w-md w-full border border-hairline bg-bone-raised rounded-lg p-8 text-center"
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <LockClosedIcon className="w-16 h-16 text-ink-muted mx-auto mb-4" />
        <h2 className="font-display text-h2 text-primary mb-2">{levelName}</h2>
        <p className="text-body text-secondary mb-6">This level is locked</p>

        <div className="border border-hairline rounded-md p-4 mb-6 bg-pine-tint text-left">
          <div className="flex items-center justify-center gap-2 mb-2">
            <AcademicCapIcon className="w-6 h-6 text-pine" />
            <span className="text-label text-pine font-medium">Requirement</span>
          </div>
          <p className="text-body text-primary text-center">{requirement}</p>
        </div>

        <button
          type="button"
          onClick={() => navigate('/learning')}
          className="btn-primary w-full py-3 text-label"
        >
          Go to Learning
        </button>

        <button
          type="button"
          onClick={() => navigate('/game/city-of-signals')}
          className="btn-secondary w-full mt-4 py-3 text-label"
        >
          Back to Level Selector
        </button>
      </motion.div>
    </div>
  );
};

export default LockedGateScreen;
